import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ButtonV2 } from '@asigna/kit';
import AsignaLogo from 'images/asigna-logo.svg';
import CheckIcon from 'images/check_icon.svg';
import CloseIcon from 'images/close.svg';

import { getApiBaseUrl } from '../../Axios/utils';

export const UnsubscribePage: React.FC = () => {
  const { search } = useLocation();
  const history = useHistory();
  const [email, setEmail] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    setEmail(urlParams.get('email'));
    setToken(urlParams.get('token'));
  }, [search]);

  const handleUnsubscribe = () => {
    setIsLoading(true);
    fetch(`${getApiBaseUrl()}email/unlink-all-email?dynamicToken=${token}`, {
      method: 'DELETE',
    })
      .then((response) =>
        response.json().then((data: { success: boolean }) => setIsSuccessful(data.success))
      )
      .finally(() => setIsLoading(false));
  };

  const unsubscribeContent = (
    <>
      <span className="p-[16px] border border-white-10 rounded-full mb-[24px]">
        <img src={CloseIcon} alt="Cross icon" />
      </span>
      <h1 className="text-r24 text-regular-fa mb-[16px]">Unsubscribe</h1>
      {Boolean(email) && (
        <p className="text-r14 text-dark-neutral-900 mb-[48px]">
          You’re about to unsubscribe from email notifications <br />
          for <span className="text-white text-m16">{email}</span>
        </p>
      )}
      <ButtonV2
        className="w-full"
        disabled={!token || !email || isLoading}
        onClick={handleUnsubscribe}
      >
        Unsubscribe from all emails
      </ButtonV2>
    </>
  );

  const resultContent = (
    <>
      <span className="p-[16px] bg-success rounded-full mb-[24px]">
        <img src={CheckIcon} alt="Checkmark icon" />
      </span>
      <h1 className="text-r24 text-regular-fa mb-[16px]">Successfully unsubscribed</h1>
      {Boolean(email) && (
        <p className="text-r14 text-dark-neutral-900 mb-[48px]">
          You have successfully unsubscribed from all email notifications <br />
          for <span className="text-white text-m16">{email}</span>
        </p>
      )}
      <ButtonV2 color="secondary" className="w-full" onClick={() => history.push('/')}>
        Go to Asigna
      </ButtonV2>
    </>
  );

  return (
    <div className="w-full h-full flex flex-col items-center text-center">
      <img src={AsignaLogo} alt="asigna logo" className="mt-[56px] mb-[70px]" />

      <div className="flex flex-col items-center p-[24px] sm:p-[40px] bg-black-1 rounded-[16px] sm:w-[600px]">
        {isSuccessful ? resultContent : unsubscribeContent}
      </div>

      <p className="text-r13 text-regular mt-auto mb-40">
        If this is not your address, an email was most likely forwarded to you from
        <br />
        someone else and you can safely ignore this message.
      </p>
    </div>
  );
};
